import { render, staticRenderFns } from "./IconFavorite.vue?vue&type=template&id=b216f6b2&scoped=true&"
import script from "./IconFavorite.vue?vue&type=script&lang=js&"
export * from "./IconFavorite.vue?vue&type=script&lang=js&"
import style0 from "./IconFavorite.vue?vue&type=style&index=0&id=b216f6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b216f6b2",
  null
  
)

export default component.exports